import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class InstalacionService {

  id: any
  instalaciones: any = []
  constructor() { }

  getAllInstalaciones() {
    return gql`
      query getAllInstalaciones {
        instalacions(sort: "createdAt:DESC"){
          id
          nombre
          cliente {
            nombreComercial
          }
          createdAt
          zonas {
            id
            nombre
          }
          campos{
            id
            nombre
            agrupacion {
              id 
              nombre
            }
          }
          direccion {
            tipoVia
            nombre
          }
          centro {
            id
            documentos{
              tipo
              estado
              
            }
          }

        }
      }
    `;
  }

  getAllInstalacionesGreen() {
    return gql`
      query getAllInstalaciones {
        instalacions(
          where: {
            estado: "verde"
          }) {
          id
          nombre
          estado
          cliente {
            nombreComercial
          }
          createdAt
          zonas {
            id
            nombre
          }
          campos{
            id
            nombre
            agrupacion {
              id 
              nombre
            }
          }
          direccion {
            tipoVia
            nombre
          }
          centro {
            id
            documentos{
              tipo
              estado
              
            }
          }

        }
      }
    `;
  }

  getAllInstalacionesYellow() {
    return gql`
      query getAllInstalaciones {
        instalacions(
          where: {
            estado: "amarillo"
          }) {
          id
          nombre
          cliente {
            nombreComercial
          }
          createdAt
          zonas {
            id
            nombre
          }
          campos{
            id
            nombre
            agrupacion {
              id 
              nombre
            }
          }
          direccion {
            tipoVia
            nombre
          }
          centro {
            id
            documentos{
              tipo
              estado
              
            }
          }

        }
      }
    `;
  }


  getAllInstalacionesRed() {
    return gql`
      query getAllInstalaciones {
        instalacions(
          where: {
            estado: "rojo"
          }) {
          id
          nombre
          cliente {
            nombreComercial
          }
          createdAt
          zonas {
            id
            nombre
          }
          campos{
            id
            nombre
            agrupacion {
              id 
              nombre
            }
          }
          direccion {
            tipoVia
            nombre
          }
          centro {
            id
            documentos{
              tipo
              estado
              
            }
          }

        }
      }
    `;
  }




  getAllInstalacionesDoughnout() {
    return gql`
      query getAllInstalaciones {
        instalacions(sort: "createdAt:DESC"){
        id
         estado
          centro {
            estado
            documentos {
              id
              estado
              tipo
            }
            transportistas {
              id
              estado
              documentos {
                id
                estado
                tipo
              }
            }
            gestors {
              id
              estado
              documentos {
                id
                estado
                tipo
              }
            }
          }

        }
      }
    `;
  }

  getInstalacionById() {
    return gql`
      query getInstalacionById($id: ID!) {
          instalacion(id: $id) {
            id
            nombre
            direccion {
              tipoVia
              nombre
              provincia
              ccaa
              codigoPostal
            }
            zonas{
              id
              nombre
            }
            campos{
              id
              nombre
              agrupacion {
                id 
                nombre
              }
            }
            contratistas {
              nombreComercial
            }
            cliente {
              xtensaBasica
            }
          }
        }
    `;
  }

  getInstalacionesByCliente() {
    return gql`
      query getInstalacionesByCliente($id: ID!){
        cliente(id: $id){
          xtensaBasica
          instalaciones{
            id
            nombre
            createdAt
            zonas {
              id
              nombre
            }
            campos {
              id
              nombre
              agrupacion {
                id
                nombre
              }
            }
            cliente {
              nombreComercial
            }
            contratistas{
              nombreComercial
            }
          }
        }
      }
    `;
  }

  getInstalacionesByContratista() {
    return gql`
      query getInstalacionesByContratista($id: ID!){
        contratista(id: $id){
       
          instalaciones{
            estado
            centro{
              id
              estado
            }
          }
        }
      }
    `;
  }


  addInstalacion() {
    return gql`
      mutation createInstalacion($input: createInstalacionInput!) {
      createInstalacion(input: $input) {
        instalacion {
          id
        }
      }
    }
    `;
  }

  updateInstalacion() {
    return gql`
      mutation updateInstalacion($input: updateInstalacionInput!) {
        updateInstalacion(input: $input) {
          instalacion {
            id
            nombre
            direccion {
              tipoVia
              nombre
              provincia
              ccaa
              codigoPostal
            }
            zonas {
              id
              nombre
            }
            campos{
              id
              nombre
            }
            contratistas {
              nombreComercial
            }
          }
        }
      }
    `;
  }

  deleteInstalacion() {
    return gql`
      mutation deleteInstalacion($input: deleteInstalacionInput!) {
        deleteInstalacion(input: $input) {
          instalacion {
            id
          }
        }
      }
    `;
  }


  getCentrosByInstalacion() {
    return gql`
      query getCentrosByGestor ($id: ID!) {
        gestor(id: $id) {
          centros {
            instalaciones {
              id
              nombre
              cliente {
                nombreComercial
              }
              createdAt
              zonas{
                id
                nombre
              }
              direccion {
                tipoVia
                nombre
                provincia
                ccaa
                codigoPostal
              }
              campos{
                id
                nombre
                agrupacion {
                  id 
                  nombre
                }
              }
            }
          }
        }
      }
    `;
  }

  getInstalacionesByTransportista() {
    return gql`
      query getInstalacionesByTransportista ($id: ID!) {
        transportista(id: $id) {
          centros {
            instalaciones {
              cliente{
                id
              }
              contratistas{
                id
              }
              id
              nombre
              createdAt
              zonas{
                id
                nombre
              }
              direccion {
                tipoVia
                nombre
                provincia
                ccaa
                codigoPostal
              }
              campos{
                id
                nombre
                agrupacion {
                  id 
                  nombre
                }
              }
            }
          }
        }
      }
    `;
  }

  getInstalacionesByGestor() {
    return gql`
      query getInstalacionesByGestor ($id: ID!) {
        gestor(id: $id) {
          centros {
            instalaciones {
              cliente{
                id
              }
              contratistas{
                id
              }
              id
              nombre
              createdAt
              zonas{
                id
                nombre
              }
              direccion {
                tipoVia
                nombre
                provincia
                ccaa
                codigoPostal
              }
              campos{
                id
                nombre
                agrupacion {
                  id 
                  nombre
                }
              }
            }
          }
        }
      }
    `;
  }

  setIdInstalacion(id: any) {
    this.id = id;
  }

  getIdInstalacion() {
    let temp = this.id;
    this.clearIdInstalacion();
    return temp;
  }

  clearIdInstalacion() {
    this.id = undefined;
  }

  setInstalaciones(instalaciones: any) {
    this.instalaciones = instalaciones;
  }

  getInstalaciones() {
    let temp = this.instalaciones;
    this.clearInstalaciones();
    return temp;
  }

  clearInstalaciones() {
    this.instalaciones = undefined;
  }

}
